/**
 * =================
 * SESSION
 * tool
 * =================
 */
app.session = (function(module) {

	var session = {
		id: cookieNames.id
	};

	module.status = _checkSession;
	module.getEvent = _getEvents;

	// fn's
	function _checkSession() {
		// NO SE USA
		// return !!app.cookie.get(session.id).trim();
		return '';
	}

	function _getEvents() {
		return ['openSession', 'closeSession'].toString().split(',');
	}

	// auxiliary
	function _closeSessionHandler(e, args) {
		app.$.ajax({
			url: args.logoutURI,
			type: 'POST'
		})
		.done(function() {
			// NO SE USA
			//app.cookie.remove(session.id);
			_reloadWindow(args.domainURI);
		});
	}

	function _reloadWindow(URL) {
		!URL ? window.location.reload(true) : window.location.replace(URL);
	}

	// kickstart!
	app.$(function() {
		_checkSession() && app.$(window).on('closeSession', _closeSessionHandler);
	});

	return module;

}(app.session || {}));



/**
 * =================
 * SESSION
 * user
 * =================
 */
app.user = (function(module) {

	// staff
  var $layer,
      $button;

	module.init = function() {
		$layer = app.$('#user-layer-session');
		$button = app.$('.user-session-button');

		if (!$layer.length || !$button.length) return;

		_bindingUserEvents();
	};

	// fn's
	function _bindingUserEvents() {
		$button.on('click', _openLayer);
  }

  // auxiliary
  function _openLayer(e) {
    e.preventDefault();
    app.lightbox.init($layer);
  }

	// kickstart!
	app.$(function() {
		module.init();
	});

	return module;

}(app.user || {}));



/**
 * =================
 * SESSION USER LOGGED
 * =================
 */

app.logged = (function(module) {

	// staff
 	var $layer,
		 	$button;
	var layerIsOpen = false;

 	module.init = function() {

	 	$layer = app.$('#logged-layer-session');
	 	$button = app.$('.logged-session-button');

	 	if (!$layer.length || !$button.length) return;

	 	_bindingUserEvents();
 	};

 	// fn's
 	function _bindingUserEvents() {
	 	$button.on('click', _openLayer);
	 	app.$(document)
		 	.on('lity:open', function(e, lbox) {
			 	if (layerIsOpen) {
				 	lbox.addClass("lity__search-theme");
			 	}
		 	})
		 	.on('lity:close', function(e, lbox) {
			 	if (layerIsOpen) {
			 		layerIsOpen = false;
				 	_.debounce(function() {
						lbox.removeClass("lity__search-theme");
				 	}, 16);
			 	}
		 });
 	}

 	// auxiliary
 	function _openLayer(e) {
		layerIsOpen = true;
	 	e.preventDefault();
	 	app.lightbox.init($layer);
 	}

	// kickstart!
 	app.$(function() {
		module.init();
 	});

 	return module;

}(app.logged || {}));


/* EOF */
